export const TOAST_POP = 'TOAST_POP';
export const SHOW_MESSAGE = 'SHOW_MESSAGE';

export function pop () {
  return { type: TOAST_POP };
}

export function push ({ error, entity }) {
  return { type: SHOW_MESSAGE, error, payload: { entity } };
}
